import {SliderAction} from './slider-swiping-actions'

const previous = (length: number, current: number) => {
  return (current - 1 + length) % length
}

const next = (length: number, current: number) => {
  return (current + 1) % length
}

interface SliderState {
  offset: number
  desired: number
  active: number
  withoutAnimate: boolean
}

export function sliderReducer(state: SliderState, action: SliderAction) {
  switch (action.type) {
    case 'jump-without-animate':
      return {
        ...state,
        desired: action.desired,
        withoutAnimate: true
      }
    case 'jump':
      return {
        ...state,
        desired: action.desired,
        withoutAnimate: false
      }
    case 'next':
      return {
        ...state,
        desired: next(action.length, state.active),
        withoutAnimate: false
      }
    case 'prev':
      return {
        ...state,
        desired: previous(action.length, state.active),
        withoutAnimate: false
      }
    case 'done':
      return {
        ...state,
        offset: NaN,
        active: state.desired,
        withoutAnimate: false
      }
    case 'drag':
      return {
        ...state,
        offset: action.offset,
        withoutAnimate: false
      }
    default:
      return state
  }
}
